import { cellNotFilter, formatDate } from "@/shared";
// import InfoUser from "@/shared/components/ui/InfoUser/InfoUser";
import { ATSExtended } from "@/shared/interfaces";
import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";


export const useColumnsATS = () => {

    const columnsATS = useMemo<MRT_ColumnDef<ATSExtended>[]>(() => [
        {
          accessorKey: 'razon_social',
          header: 'Nombre',
          size: 300,
          Cell: ({ row }) => (
            row.original?.prospecto_data?.razon_social || "N/A"
          ),
        },
        {
          accessorKey: 'identificacion',
          header: 'Identificacion',
          size: 200,
          Cell: ({ row }) => (
            row.original?.prospecto_data?.identificacion || "N/A"
          ),
        },
        {
          accessorKey: 'flota',
          header: 'Flota',
          size: 200,
          Cell: ({ row }) => (
            row.original?.flota_data?.nombre || "N/A"
          ),
        },
        {
          ...cellNotFilter,
          accessorKey: 'fecha_creacion',
          header: 'Fecha Creación',
          size: 100,
          Cell: ({ row }) => (
            formatDate(row.original?.fecha_creacion || "") || "N/A"
          ),
        },
        {
          ...cellNotFilter,
          accessorKey: 'fecha_modificacion',
          header: 'Última Modificación',
          size: 100,
          Cell: ({ row }) => (
            formatDate(row.original?.fecha_modificacion||"") || "N/A"
          ),
        },
    
    ], []);


    return {
        columnsATS
    }
}

